import axios from "axios";

export class APIError extends Error {
    readonly traceID: string | undefined;
    readonly status: number | undefined;
    readonly data: unknown;

    constructor(message: string, status?: number, traceID?: string, data?: unknown) {
        super(message);
        this.name = "APIError";
        this.status = status;
        this.traceID = traceID;
        this.data = data;
    }

    get errors(): Record<string, string[]> | undefined {
        if (this.data && typeof this.data === "object" && "errors" in this.data) {
            return (this.data as { errors: Record<string, string[]> }).errors;
        }
        return undefined;
    }
}

export function platformAPIErrorInterceptor(error: unknown): never {
    if (axios.isAxiosError(error)) {
        const status = error.response?.status;
        const data = error.response?.data as Record<string, unknown> | undefined;
        const msg = (data?.error as string | undefined) ?? error.message;
        const traceID = error.response?.headers?.["trace-id"] as string | undefined;
        throw new APIError(msg, status, traceID, data);
    }
    throw error;
}
